import React, { useState, useEffect, useContext } from "react";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth"; 
import { auth } from "../firebase";
import { useNavigate, useLocation } from "react-router-dom";
import Scale from "../assets/images/scale.webp";
import { AuthContext } from "../App";
import "../styles/AuthPage.css";

const COURSE_OPTIONS = [
  { value: "BALLB", label: "BALLB 5YDC" },
  { value: "BBALLB", label: "BBALLB 5YDC" },
  { value: "BCOMLLB", label: "BCOMLLB 5YDC" },
  { value: "3YDC", label: "LLB 3YDC" },
  { value: "AIBE Preparation", label: "AIBE Preparation" },
];

const AuthPage = () => {
  const { currentUser, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [activeTab, setActiveTab] = useState("login");

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  // Form states
  const [signupName, setSignupName] = useState("");
  const [signupEmail, setSignupEmail] = useState("");
  const [signupPassword, setSignupPassword] = useState("");
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  // SignUp handler
  const handleSignUp = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        signupEmail,
        signupPassword,
      );

      await sendEmailVerification(userCredential.user);
      alert("Verification email sent! Please check your inbox.");

      // DO NOT navigate yet
      setUserProfile({ name: signupName });
      setShowProfileModal(true);
    } catch (error) {
      alert(error.message);
    }
  };

  // Login handler
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        loginEmail,
        loginPassword,
      );
      const user = userCredential.user;
      if (!user.emailVerified) {
        alert("Please verify your email before logging in!");
      } else {
        localStorage.setItem("username", user.displayName || "User");

        const existingProfile = localStorage.getItem("tejcodex_user");

        if (!existingProfile) {
          setUserProfile({ name: user.displayName || "" });
          setShowProfileModal(true);
        } else {
          navigate(from, { replace: true });
        }
      }
    } catch (error) {
      alert(error.message);
    }
  };

  // Google login
  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();

    try {
      const result = await signInWithPopup(auth, provider);
      const googleUser = result.user;

      const existingProfile = localStorage.getItem("tejcodex_user");

      if (!existingProfile) {
        setUserProfile({ name: googleUser.displayName || "" });
        setShowProfileModal(true);
      } else {
        navigate(from, { replace: true });
      }
    } catch (error) {
      alert(error.message);
    }
  };

  const handleLoginSuccess = (googleUser) => {
    const existingProfile = localStorage.getItem("tejcodex_user");

    if (!existingProfile) {
      setShowProfileModal(true);
    } else {
      setUserProfile(JSON.parse(existingProfile));
    }
  };

  useEffect(() => {
    if (!loading && currentUser) {
      const existingProfile = localStorage.getItem("tejcodex_user");
      if (existingProfile) {
        navigate(from, { replace: true });
      }
    }
  }, [currentUser, loading, navigate, from]);

  useEffect(() => {
    if (userProfile) {
      setShowProfileModal(true);
    }
  }, [userProfile]);
  // Back button
  const handleBack = () => {
    navigate("/");
  };
  const isProfileValid =
    userProfile?.name?.trim() &&
    userProfile?.course &&
    (userProfile.course === "AIBE Preparation" || userProfile?.year);
  return (
    <>
      {showProfileModal && (
        <div className="profile-modal-overlay">
          <div className="profile-modal">
            <h2>Complete Your Details</h2>
            <input required
              type="text"
              placeholder="Your Name"
              value={userProfile?.name || ""}
              onChange={(e) =>
                setUserProfile({ ...userProfile, name: e.target.value })
              }
            />
            <select required
              value={userProfile?.course || ""}
              onChange={(e) =>
                setUserProfile({
                  ...userProfile,
                  course: e.target.value,
                  year: "",
                })
              }
            >
              <option value="">Select Course</option>
              {COURSE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {userProfile?.course && userProfile.course !== "AIBE Preparation" && (
              <select
                value={userProfile?.year || ""}
                onChange={(e) =>
                  setUserProfile({ ...userProfile, year: e.target.value })
                }
              >
                <option value="">Select Year</option>

                {(userProfile.course === "3YDC"
                  ? ["1st Year", "2nd Year", "3rd Year"]
                  : ["1st Year", "2nd Year", "3rd Year", "4th Year", "5th Year"]
                ).map((yr, idx) => (
                  <option key={idx} value={yr}>
                    {yr}
                  </option>
                ))}
              </select>
            )}
            <button
              disabled={!isProfileValid}
              style={{
                opacity: !isProfileValid ? 0.6 : 1,
                cursor: !isProfileValid ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (!userProfile?.name?.trim()) {
                  alert("Please enter your name.");
                  return;
                }
                if (!userProfile?.course) {
                  alert("Please select your course.");
                  return;
                }
                if (userProfile?.course !== "AIBE Preparation" && !userProfile?.year) {
                  alert("Please select your year.");
                  return;
                }

                localStorage.setItem(
                  "tejcodex_user",
                  JSON.stringify(userProfile),
                );
                setShowProfileModal(false);
                navigate(from, { replace: true });
              }}
            >
              Save & Continue
            </button>{" "}
          </div>
        </div>
      )}

      <div className="auth-container">
        {/* Back Button */}
        <button className="back-btn top-left" onClick={handleBack}>
          ← Back to Home
        </button>

        {/* Left Section */}
        <div className="auth-left">
          <img src={Scale} alt="Scale" />
        </div>

        {/* Right Section */}
        <div className="auth-right">
          <h1 className="auth-heading">TejCodex</h1>

          <div className="auth-tabs">
            <button
              className={activeTab === "login" ? "active-tab" : ""}
              onClick={() => setActiveTab("login")}
            >
              Login
            </button>
            <button
              className={activeTab === "signup" ? "active-tab" : ""}
              onClick={() => setActiveTab("signup")}
            >
              Sign Up
            </button>
          </div>

          <div className="auth-form-container">
            {activeTab === "signup" && (
              <form className="signup-form" onSubmit={handleSignUp}>
                <h2>Sign Up</h2>
                <p>
                  Don’t have an account? Create here and access TejCodex Free
                  Notes
                </p>
                <input
                  type="text"
                  placeholder="Full Name"
                  value={signupName}
                  onChange={(e) => setSignupName(e.target.value)}
                  required
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={signupEmail}
                  onChange={(e) => setSignupEmail(e.target.value)}
                  required
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={signupPassword}
                  onChange={(e) => setSignupPassword(e.target.value)}
                  required
                />
                <button type="submit" className="primary-btn">
                  Sign Up
                </button>
              </form>
            )}

            {activeTab === "login" && (
              <form className="login-form" onSubmit={handleLogin}>
                <h2>Login</h2>
                <p>Login with your email directly or continue with Google</p>
                <input
                  type="email"
                  placeholder="Email"
                  value={loginEmail}
                  onChange={(e) => setLoginEmail(e.target.value)}
                  required
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                  required
                />
                <button type="submit" className="primary-btn">
                  Login
                </button>
                <button
                  type="button"
                  className="google-btn"
                  onClick={handleGoogleLogin}
                >
                  <img
                    src="https://www.svgrepo.com/show/475656/google-color.svg"
                    alt="Google"
                    style={{ width: "20px", height: "20px" }}
                  />
                  Continue with Google
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthPage;
